import React from 'react'
import Helmet from 'react-helmet'
import favicon16 from "../assets/images/favicon16.png";
import favicon32 from "../assets/images/favicon32.png";
import favicon64 from "../assets/images/favicon64.png";

const ContactPage = () => (
  <div className="section contact-section has-text-centered">
    <Helmet
      title="Contact Rekon Technologies"
      meta={[
        { name: 'description', content: 'Contact Rekon Technologies' }
      ]}
       link={[
        { rel: "icon", type: "image/png", sizes: "16x16", href: `${favicon16}` },
        { rel: "icon", type: "image/png", sizes: "32x32", href: `${favicon32}` },
        { rel: "shortcut icon", type: "image/png", href: `${favicon64}` },
       ]}
    />
    <h1 className="title fg-primary">We Are Here to Help</h1>
    <section className="container">
      <div className="columns">
        <div className="column">
          <h2 className="title">Sales</h2>
          <p>
          (626) 577-4350 <br/>
          <a href="mailto:sales@rekon.com">sales@rekon.com</a>
          </p>
        </div>
        <div className="column">
          <h2 className="title">Support</h2>
          <p>
          (626) 577-4350 <br/>
          <a href="mailto:techsupport@rekon.com">techsupport@rekon.com</a>
          </p>
        </div>
        <div className="column">
          <h2 className="title">Address</h2>
          <p>
          100 W. Broadway, Suite 920 <br/>
          Glendale, CA 91210
          </p>
        </div>
      </div>
    </section>
  </div>
)

export default ContactPage



// WEBPACK FOOTER //
// ./src/pages/contact.js